/* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
import React, { PureComponent } from 'react';
import { func } from 'prop-types';
import styled from 'styled-components';
import Button, { ButtonVariations } from '../../../../../../SolvPatternLibrary/Button';
import { colors } from '../../../../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../../../../constants/text';
import NextReminder, {
  NINE_MONTHS_IN_DAYS,
  SIX_MONTHS_IN_DAYS,
  THREE_MONTHS_IN_DAYS,
  TWELVE_MONTHS_IN_DAYS,
} from './NextReminder';
import { analyticsTrackEvent } from '../../../../../../../core/analytics';
import {
  REMINDERS_ACTION,
  REMINDERS_SET_LAST_CHECKUP_TIME,
} from '../../../../../../Account/Profile/Reminders/util/tracking';
import { remindersSpec } from '../../../../../../Account/Profile/Reminders/util/reminders';
import { Tile } from '../Tile';

const Root = styled.div.withConfig({ componentId: 'sc-xn7ec2-0' })`
  padding: 24px;
`;

const Title = styled.div.withConfig({ componentId: 'sc-xn7ec2-1' })`
  font-size: ${fontSize.large};
  font-family: ${fontFamily.bold};
  color: ${colors.fadeToBlack};
`;

const ReminderButton = styled(Button).withConfig({ componentId: 'sc-xn7ec2-2' })`
  height: 40px;
  width: 100%;
  display: block;
  padding: 0;
  border: 1px solid #ccd0d3;
  margin: 16px 0;
  color: ${colors.blueJayWay};
`;

type Props = {
  activeTile?: Tile | null;
  openModal: (
    modalId?: string | null,
    options?: {
      lastCheckupResponseInDays: number;
    }
  ) => any;
};

export default class LastCheckup extends PureComponent<Props> {
  static MODAL_ID = 'last-checkup';

  title: any;

  constructor(props: Props) {
    super(props);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'reminder_type' does not exist on type 'o... Remove this comment to see the full error message
    // eslint-disable-next-line camelcase
    const { reminder_type } = this.props.activeTile;
    this.title = remindersSpec[reminder_type].whenWasYourLastTitle;
  }

  handler = (lastCheckupResponseInDays: any) => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'reminder_type' does not exist on type 'o... Remove this comment to see the full error message
    // eslint-disable-next-line camelcase
    const { reminder_type, title } = this.props.activeTile;
    analyticsTrackEvent(REMINDERS_ACTION, {
      reminderType: reminder_type,
      title,
      action: REMINDERS_SET_LAST_CHECKUP_TIME,
      lastCheckupResponseInDays,
    });
    this.props.openModal(NextReminder.MODAL_ID, {
      ...this.props.activeTile,
      lastCheckupResponseInDays,
    });
  };

  render = () => (
    <Root>
      <Title>{this.title}</Title>

      <ReminderButton
        onClick={() => this.handler(THREE_MONTHS_IN_DAYS)}
        variation={ButtonVariations.tertiary}
      >
        1 - 3 months ago
      </ReminderButton>

      <ReminderButton
        onClick={() => this.handler(SIX_MONTHS_IN_DAYS)}
        variation={ButtonVariations.tertiary}
      >
        3 - 6 months ago
      </ReminderButton>

      <ReminderButton
        onClick={() => this.handler(NINE_MONTHS_IN_DAYS)}
        variation={ButtonVariations.tertiary}
      >
        6 - 9 months ago
      </ReminderButton>

      <ReminderButton
        onClick={() => this.handler(TWELVE_MONTHS_IN_DAYS)}
        variation={ButtonVariations.tertiary}
      >
        9 - 12 months ago
      </ReminderButton>

      <ReminderButton
        onClick={() => this.handler(TWELVE_MONTHS_IN_DAYS + THREE_MONTHS_IN_DAYS)}
        variation={ButtonVariations.tertiary}
      >
        Over a year ago
      </ReminderButton>
    </Root>
  );
}
